import { goalsRequests } from './goals'
import { needsRequests } from './needs'
import { residentsRequests } from './residents'
import { usersRequests } from './users'

const requests = {
  residents: residentsRequests,
  needs: needsRequests,
  users: usersRequests,
  goals: goalsRequests
}

export default requests
